import { render } from "./QuotaAdjustment.vue?vue&type=template&id=3848000f&scoped=true&ts=true"
import script from "./QuotaAdjustment.vue?vue&type=script&lang=ts"
export * from "./QuotaAdjustment.vue?vue&type=script&lang=ts"

import "./QuotaAdjustment.vue?vue&type=style&index=0&id=3848000f&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3848000f"]])

export default __exports__